import { render, staticRenderFns } from "./ModuleSubNav.vue?vue&type=template&id=03681b57&scoped=true"
import script from "./ModuleSubNav.vue?vue&type=script&lang=js"
export * from "./ModuleSubNav.vue?vue&type=script&lang=js"
import style0 from "./ModuleSubNav.vue?vue&type=style&index=0&id=03681b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03681b57",
  null
  
)

export default component.exports